module.exports = __webpack_public_path__ + "static/media/prb-nutri-site-landingpage-1-768x591.80c39cbd.jpg";